"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityActivityParticipants = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const mstr_activity_entity_1 = require("./mstr-activity.entity");
const user_1 = require("./user");
let OpportunityActivityParticipants = class OpportunityActivityParticipants {
    constructor(id, opportunityId, activityId, participantId, createdAt, updatedAt, createdBy, updatedBy, opportunityActivityId) {
        this.id = id;
        this.opportunityId = opportunityId;
        this.activityId = activityId;
        this.participantId = participantId;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.createdBy = createdBy;
        this.updatedBy = updatedBy;
        this.opportunityActivityId = opportunityActivityId;
    }
};
exports.OpportunityActivityParticipants = OpportunityActivityParticipants;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityParticipants.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityParticipants.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityParticipants.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "activity_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityParticipants.prototype, "activityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => mstr_activity_entity_1.MstrActivity, (activity) => activity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "activity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityParticipants.prototype, "activity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "participant_id" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityParticipants.prototype, "participantId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_1.User, (participant) => participant.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "participant_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityActivityParticipants.prototype, "participant", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_activity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityParticipants.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], OpportunityActivityParticipants.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], OpportunityActivityParticipants.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityParticipants.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], OpportunityActivityParticipants.prototype, "updatedBy", void 0);
exports.OpportunityActivityParticipants = OpportunityActivityParticipants = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_activity_participants"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, Number, typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object, typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object, Number, Number, Number])
], OpportunityActivityParticipants);
